import { useRegistrationStore } from '../../hooks';
import { TaskRegistrationModalView } from '../../components/TaskRegistrationModalView';

export const TaskRegistrationModal = () => {
  const registrationStore = useRegistrationStore();

  return <TaskRegistrationModalView {...registrationStore} />;
};
